import { render } from "./BaseFormFooter.vue?vue&type=template&id=20f8270a&scoped=true"
import script from "./BaseFormFooter.vue?vue&type=script&lang=js"
export * from "./BaseFormFooter.vue?vue&type=script&lang=js"

import "./BaseFormFooter.vue?vue&type=style&index=0&id=20f8270a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20f8270a"]])

export default __exports__